var React = require('react');

function Telegram (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.024 25.7235L20.4287 34.2353L24.8617 29.802L32.444 35.829L37.9461 12.1875L10.5176 23.1954L17.024 25.7235ZM14.8847 23.1713L27.9586 17.9242L17.5618 24.2116L14.8847 23.1713ZM30.2884 18.3901L21.6108 26.3287L20.567 30.2622L18.6366 25.4362L30.2884 18.3901ZM22.2606 30.1346L22.7865 28.1526L23.5978 28.7974L22.2606 30.1346ZM31.4565 32.995L23.5608 26.719L35.4484 15.8435L31.4565 32.995Z","fill":"white"}));
}

Telegram.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Telegram;

Telegram.default = Telegram;
